export default __webpack_public_path__ + "static/media/2mm_bag.99df75ab.jpg";